import {defineStore} from "pinia";
import { ref } from 'vue';
import axios from "axios";

export default defineStore('categoryCountStore', () => {

    const loading = ref(true);
    const counts = ref({});
    const isLoading = ref(false);

    const loadCounts = (groupId, query, manufacturer) => {
        if (isLoading.value === true) return;
        loading.value = isLoading.value = true;
        axios.get('/count-group-products/count', {params: {groupId, query, manufacturer}}).then((response) => {
            counts.value = response.data;
            loading.value = isLoading.value = false;
        })
    }

    return {
        loadCounts,
        counts,
        loading
    }
});
